// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1lFVo","inner":"Footer_inner__1Eupp","nextIcon":"Footer_nextIcon__1j3Qr","innerLeft":"Footer_innerLeft__sj9Qh"};